"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useAccordionContext_1 = require("./useAccordionContext");
var styled_1 = __importDefault(require("./styled"));
var element = function (Component) { return (0, styled_components_1.default)(Component)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]))); };
var AccordionButton = function (_a) {
    var icon = _a.icon, _b = _a.headingElement, headingElement = _b === void 0 ? 'h3' : _b, index = _a.index, isDisabled = _a.isDisabled, children = _a.children;
    var _c = (0, useAccordionContext_1.useAccordionContext)(), findExpanded = _c.findExpanded, renderIcon = _c.renderIcon, handleExpandItems = _c.handleExpandItems;
    var isExpanded = findExpanded(index);
    var accordionIcon = renderIcon({ isExpanded: isExpanded, icon: icon });
    var HeadingElement = element(headingElement);
    return (react_1.default.createElement(HeadingElement, null,
        react_1.default.createElement(styled_1.default.Button, { "data-testid": "accordion-button-" + index, "aria-expanded": isExpanded, "aria-controls": "accordion-item-" + index, id: "button-id-" + index },
            react_1.default.createElement("span", { onClick: function () { return handleExpandItems({ index: index, isExpanded: isExpanded, isDisabled: isDisabled }); } },
                children,
                accordionIcon))));
};
exports.default = AccordionButton;
var templateObject_1;
